import * as firebase from 'firebase';
// import firestore from 'firebase/firestore'


const config = {
    apiKey: "AIzaSyAMFVaFJXwVcKo1t25uoayBFXhH4dhOuRs",
    authDomain: "losplatosmenus.firebaseapp.com",
    databaseURL: "https://losplatosmenus.firebaseio.com",
    projectId: "losplatosmenus",
    storageBucket: "losplatosmenus.appspot.com",
    messagingSenderId: "622597987767",
    appId: "1:622597987767:web:fba1ca8767ff739ccc9c32",
    measurementId: "G-XKG8B25FLW"
};
firebase.initializeApp(config);

firebase.firestore();

export default firebase;